/**
 * Fireblocks integration API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FireblocksDepositVault } from './fireblocksDepositVault';

export interface SourceVaultResponse {
  vaultKeyType?: SourceVaultResponse.VaultKeyTypeEnum;
  fireblocksDepositVault?: FireblocksDepositVault;
}
export namespace SourceVaultResponse {
  export const VaultKeyTypeEnum = {
    MainVaultFireblocksKey: 'MAIN_VAULT_FIREBLOCKS_KEY',
    BtcVaultFireblocksKey: 'BTC_VAULT_FIREBLOCKS_KEY',
    AutomatedVaultFireblocksKey: 'AUTOMATED_VAULT_FIREBLOCKS_KEY',
    GasStationVaultNameKey: 'GAS_STATION_VAULT_NAME_KEY',
  } as const;
  export type VaultKeyTypeEnum = (typeof VaultKeyTypeEnum)[keyof typeof VaultKeyTypeEnum];
}
